// extracted by mini-css-extract-plugin
module.exports = {"container":"transcript-summary__container___2X_GB","buttons":"transcript-summary__buttons___1Aep4","footer":"transcript-summary__footer___9aoEj"};